// extracted by mini-css-extract-plugin
export var container = "challenges-module--container--ipRDL";
export var title = "challenges-module--title--buyvW";
export var list = "challenges-module--list--y1S-I";
export var item = "challenges-module--item--i+zCh";